import { http } from "./http";
import Cookies from "js-cookie";

/**
 * 로그인
 */
export async function login(id, pw) {
  try {
    const body = {
      u_id: id,
      u_pwd: pw
    };
    const res = await http.post(`/api/login`, body);
    if (res.data.code === 1) {
      Cookies.set("Authorization", res.data.data.Authorization);
      Cookies.set("RefreshToken", res.data.data.RefreshToken);
      Cookies.set("u_id", id);
      Cookies.set("u_name", res.data.data.userInfo.u_name);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("로그인: ", error);
    return false;
  }
}

/**
 * 사용자 아이디(중복) 체크
 */
export async function checkUserIdEnabled(u_id) {
  try {
    const res = await http.get(`/user/check/${u_id}`);
    const isEnabled = res?.data?.inEnabled;
    return isEnabled;
  } catch (err) {
    console.error("사용자 아이디 중복 체크: ", err);
    // throw err;
    return false;
  }
}

// 회원 가입
export async function createMember(newMember) {
  try {
    const body = {
      u_id: newMember.id,
      u_pwd: newMember.pw,
      u_name: newMember.name
    };
    const res = await http.post(`/api/join`, body);
    if (res.data.code === 1) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error("회원가입: ", err);
    return false;
  }
}

// 사용자 조회
export async function getMember() {
  try {
    const res = await http.get(`/user/employee`);
    const userList = res?.data?.userList;
    return userList;
  } catch (err) {
    console.error("사용자 조회: ", err);
    return [];
  }
}

// 비밀번호 초기화
export async function initPassword(id) {
  try {
    const body = {
      u_id: id
    };
    const res = await http.patch(`/user/init`, body);
    if (res.data.code === 1) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error("비밀번호 초기화: ", err);
    return false;
  }
}

// 사용자 비밀번호 변경
export async function chgPassword(oldPw, newPw) {
  try {
    const body = {
      oldPwd: oldPw,
      newPwd: newPw
    };
    const res = await http.patch(`/user/me/pwd`, body);
    if (res.data.code === 1) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error("사용자 비밀번호 변경: ", err);
    return false;
  }
}

// 탈퇴
export async function deleteMember(id) {
  try {
    const res = await http.delete(`/user`, {
      data: {
        u_id: id
      }
    });
    if (res.data.code === 1) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error("탈퇴: ", err);
    return false;
  }
}
